const exportedObject = {
  getVoucherData: {},
  getVoucherLoading: false,
  getVoucherError: null,

  getVoucherGmmData: {},
  getVoucherGmmLoading: false,
  getVoucherGmmError: null,
};

export default exportedObject;